import { SourcePlatform } from "../consts";
var MOBILE_WEB_REGEX = /cotdmob|m.catch/;
export var getSourcePlatform = function getSourcePlatform() {
  return MOBILE_WEB_REGEX.test(true ? window.location.host : "") ? "MOBILE" : "DESKTOP";
};
export var getSourcePlatformId = function getSourcePlatformId() {
  return getSourcePlatform() === "MOBILE" ? SourcePlatform.MOBILE_WEB : SourcePlatform.WEB;
};